import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import AmazonLinksSection from '../components/sections/AmazonLinksSection';
import usePageTitle from '../hooks/usePageTitle';
import '../styles/pages/ShopPage.css';

const ShopPage = () => {
  usePageTitle('Shop', 'Hand-picked cookie-decorating tools and supplies, recommended by The Icing Calculator.');
  return (
    <div className="shop-page">

      <div className="return-link-container return-link-top">
        <Link to="/" className="return-link">← Return to The Icing Calculator</Link>
      </div>

      {/* Hero */}
      <div className="shop-hero">
        <div className="shop-hero-icon"><ShoppingBag size={44} aria-hidden="true" /></div>
        <h1 className="shop-hero-title">My Recommended Products</h1>
        <p className="shop-hero-sub">
          The tools I actually keep on my own decorating table. If it's listed here, I use it.
        </p>
      </div>

      {/* Product grid */}
      <AmazonLinksSection />

      {/* Affiliate disclaimer */}
      <p className="shop-disclaimer">
        This page contains affiliate links. As an Amazon Associate, I earn a small commission
        from qualifying purchases, at no extra cost to you. Thank you for supporting The Icing Calculator!
      </p>

      <div className="return-link-container return-link-bottom">
        <Link to="/" className="return-link">← Return to The Icing Calculator</Link>
      </div>

    </div>
  );
};

export default ShopPage;
